export default __webpack_public_path__ + "static/gift-zombie-899a1c3c815aa57ba2c75567841cb519.mp4";